import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { copy, packItems, volumes, volumesIntro } from '../data/noklar';
export function WhatsInside() {
  const [active, setActive] = useState<number>(0);
  const volume = volumes[active];
  return <section id="inside" className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-286" data-mp="puj9rfss4567">
      <div className="mx-auto max-w-6xl" data-id="element-287" data-mp="b5wlupp3653d">
        <h2 className="mx-auto max-w-3xl text-center font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-288" data-mp="b551kb0xvtse">
          {copy.inside.title} <em className="text-red-700" data-id="element-289" data-mp="26jatslbd8gj">{copy.inside.brand}</em>?
        </h2>

        <div className="mt-16 grid gap-6 lg:grid-cols-12 lg:items-end" data-id="element-290" data-mp="74unsc6wnz2z">
          <h3 className="font-serif text-3xl leading-tight text-slate-900 sm:text-4xl lg:col-span-6" data-id="element-291" data-mp="72qjvu90b02p">
            {volumesIntro.title}
          </h3>
          <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-6" data-id="element-292" data-mp="3tcay8k7pi6zn">{volumesIntro.text}</p>
        </div>

        <div role="tablist" aria-label="Volymer" className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6" data-id="element-293" data-mp="3csmgsxq9z7bw">
          {volumes.map((item, index) => {
          const isActive = index === active;
          return <button key={item.number} type="button" role="tab" id={`volume-tab-${index}`} aria-selected={isActive} aria-controls="volume-panel" onClick={() => setActive(index)} className={`flex h-56 flex-col rounded-lg border-r-8 border-black/10 p-4 text-left shadow-xl shadow-slate-900/20 transition-[transform,opacity] duration-200 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-red-700/40 sm:h-64 lg:h-72 ${item.spine} ${isActive ? '-translate-y-2' : 'opacity-75 hover:-translate-y-1 hover:opacity-100'}`} data-id="element-294" data-mp="3lu2jejaum55k" data-mpi={index}>
                <span className="text-xs font-semibold opacity-80" data-id="element-295" data-mp="2affg2ksof0y3">{item.number}</span>
                <span className="mt-1 break-words font-serif text-2xl leading-none lg:text-[1.6rem]" data-id="element-296" data-mp="2ad2p5i4xxg8w">{item.level}</span>
                <span className={`mt-auto border-t pt-3 text-sm font-medium leading-snug ${item.rule}`} data-id="element-297" data-mp="9dhb5cqa4tnw">
                  {item.title}
                </span>
              </button>;
        })}
        </div>

        <div id="volume-panel" role="tabpanel" aria-labelledby={`volume-tab-${active}`} className="mt-8 border-t border-slate-900/15 pt-10" data-id="element-298" data-mp="j3ake72y8woz">
          <AnimatePresence mode="wait" initial={false} data-id="element-299" data-mp="o1kj2rnvuffc">
            <motion.div key={volume.number} initial={{
            opacity: 0,
            y: 6
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -6
          }} transition={{
            duration: 0.18,
            ease: [0.23, 1, 0.32, 1]
          }} className="grid gap-10 lg:grid-cols-12" data-id="element-300" data-mp="3mjzmngvi1k8u">
              <div className="lg:col-span-5" data-id="element-301" data-mp="599l9c8357o3">
                <p className="text-sm font-semibold text-red-700" data-id="element-302" data-mp="1bshnljdcmagk">
                  {volume.number} · {volume.level}
                </p>
                <h4 className="mt-2 font-serif text-3xl leading-tight text-slate-900 sm:text-4xl" data-id="element-303" data-mp="1goybccgmymt4">{volume.title}</h4>
                <p className="mt-4 text-lg leading-relaxed text-slate-900/80" data-id="element-304" data-mp="31amtd3bl63xi">{volume.tagline}</p>
                <p className="mt-3 leading-relaxed text-slate-900/70" data-id="element-305" data-mp="2wc37t40wmu5o">{volume.intro}</p>
              </div>
              <div className="lg:col-span-7" data-id="element-306" data-mp="2mjxhdyqawksl">
                <p className="text-sm font-semibold text-slate-900/60" data-id="element-307" data-mp="2mj4hnhprevjy">Innehåller</p>
                <ul className="mt-4 grid gap-x-8 gap-y-3 sm:grid-cols-2" data-id="element-308" data-mp="2hl2xsukies7f">
                  {volume.items.map(entry => <li key={entry} className="flex gap-3 text-[15px] leading-snug text-slate-900/80" data-id="element-309" data-mp="2di6botvrgdyq">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-700" strokeWidth={2.5} aria-hidden="true" data-id="element-310" data-mp="28l7h6a86q500" />
                      {entry}
                    </li>)}
                </ul>
                <p className="mt-6 font-serif text-xl italic leading-snug text-slate-900/80" data-id="element-311" data-mp="6rqdtir37qb2">{volume.outro}</p>
                {volume.note && <p className="mt-3 text-xs leading-relaxed text-slate-900/60" data-id="element-312" data-mp="1u861vot3h4n">{volume.note}</p>}
              </div>
            </motion.div>
          </AnimatePresence>
        </div>

        <div className="mt-24 border-t border-slate-900/15 pt-12" data-id="element-313" data-mp="2zlyp4pfmyrug">
          <div className="grid gap-6 lg:grid-cols-12 lg:items-end" data-id="element-314" data-mp="2lnqtqly8zyle">
            <h3 className="font-serif text-3xl leading-tight text-slate-900 sm:text-4xl lg:col-span-6" data-id="element-315" data-mp="2lplarp6ef6k7">
              {copy.inside.packTitle}
            </h3>
            <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-6" data-id="element-316" data-mp="2bwmfxpkb6js5">
              {copy.inside.packText}
            </p>
          </div>
          <ul className="mt-12 grid gap-x-10 gap-y-12 sm:grid-cols-2 lg:grid-cols-3" data-id="element-317" data-mp="22wzgh9b53o1q">
            {packItems.map(item => {
            const Icon = item.icon;
            return <li key={item.title} data-id="element-318" data-mp="27wc1doigal1o">
                  <Icon className="h-6 w-6 text-red-700" strokeWidth={1.75} aria-hidden="true" data-id="element-319" data-mp="1sz36iktxuz57" />
                  <h4 className="mt-4 font-serif text-2xl leading-tight text-slate-900" data-id="element-320" data-mp="1xxwig8tkui39">{item.title}</h4>
                  <p className="mt-2 text-sm leading-relaxed text-slate-900/70" data-id="element-321" data-mp="1ebuob027ptjq">{item.text}</p>
                </li>;
          })}
          </ul>
        </div>
      </div>
    </section>;
}